<template>
  <div class="home">
    <site-header></site-header>
    <section-nav></section-nav>
    <sections></sections>
  </div>
</template>

<script>
  import SiteHeader from './SiteHeader.vue'
  import Sections from './Sections'
  import SectionNav from './SectionNav.vue'

  export default {
    name: 'Home',
    components: {
      Sections,
      SectionNav,
      SiteHeader
    },
    mounted() {
      if (this.$route.name === 'Prerender') {
        setTimeout(() => {
          window.scrollTo(0,document.body.scrollHeight);
          setTimeout(() => {
            if (document.dispatchEvent) {
              document.dispatchEvent(new Event('prerender-event'));
            }
          }, 5000);
        }, 5000);
      }
    }
  }
</script>

<style lang="scss">
  @import '~bulma-scss/scss/utilities/functions';
  @import '~bulma-scss/scss/utilities/variables';
  @import '~bulma-scss/scss/utilities/mixins';
  @import '~bulma-scss/scss/base/minireset';

  // Overwrite bulma variables
  @import '.././assets/variables';
  @import '.././assets/custom-mixins';

  @import '~bulma-scss/scss/base/generic';
  @import '~bulma-scss/scss/grid/all';

  $orange : #f5683b;

  @font-face {
    font-family: 'angelique_roseregular';
    src: url('../assets/angelique-rose-font-webfont.woff2') format('woff2'), url('../assets/angelique-rose-font-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }

  html {
    background-color: #d5eeef;
  }

  body {
    font-family: "Gotham A", "Gotham B";
    font-style: normal;
    font-weight: 400;
    @media screen and (max-width: 768px) {
      position: absolute;
      width: 100%;
      max-width: 100%;
    }
  }

  .home {
    min-height: 100vh;
  }

  .container {
    position: relative;

    @include desktop {
      margin: 0 auto;
      max-width: 1238px;
    }

    @include widescreen {
      max-width: 1238px;
    }
  }

  .column {
    padding: 0 1.5rem;
  }

  main.onlinecity {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue